'use strict';

var WS = global.MozWebSocket || global.WebSocket;

module.exports = {
  create: function(url, protocols, options) {
    if (typeof WS !== 'function') return null;
    return new WS(url);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/faye/src/util/websocket/browser_websocket.js
// module id = 308
// module chunks = 0